import { useState, useRef, useEffect, Fragment } from "react";
import { Modal, ModalBody, ModalFooter, Form, Button, Input } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
//Language
import { useIntl } from "react-intl";

//views
import LogoutPrompt from "../logoutPrompt";

//Actions
import {
    changePasswordOpenModal,
    changePasswordRequest,
    clearRedux,
    openModalLogoutPrompt
} from 'Redux/actions';

//Notification
import {
    NotificationManager
} from "Components/Notifications";

//Helpers
import { passwordValidation } from 'Utils/helpers';

//Styles
import "./changePassword.scss";

const ChangePassword = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef();

    //redux states
    const openModal = useSelector(state => state.securityRedux.openModalChangePassword);
    const loading = useSelector(state => state.securityRedux.loadingChangePassword);
    const result = useSelector(state => state.securityRedux.resultChangePassword);
    const error = useSelector(state => state.securityRedux.errorChangePassword);
    const user = useSelector(state => state.securityRedux.user);
    const logoutPromptOpenModal = useSelector(state => state.logoutPromptRedux.openModal);

    //local states
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validPassword, setValidPassword] = useState(null);

    const closeModal = () => {
        dispatch(changePasswordOpenModal(false))
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setValidPassword("");
    }

    useEffect(() => {
        if (result) {
            NotificationManager.success(messages['change_password_changed'], messages['change_password_title'], 3000, null, null, '', null);
            //closeModal();
            dispatch(openModalLogoutPrompt());
            dispatch(clearRedux("AUTH", { resultChangePassword: null, }));
        }
        if (error) {
            if (error?.error) {
                try {
                    let message = error?.error.replace("NotAuthorizedException: ", "")
                    message = message.replace("LimitExceededException: ", "")
                    if (message.includes("Incorrect username")) {
                        message = messages['change_password_incorrect']
                    }
                    if (message.includes("limit exceeded")) {
                        message = messages['change_password_limit_exceeded']
                    }
                    NotificationManager.error(message, messages['change_password_title'], 3000, null, null, '', null);
                } catch (error) { }
            }
            dispatch(clearRedux("AUTH", { errorChangePassword: null, }));
        }
    }, [result, error]);

    return (
        <>
            <Modal
                open={openModal}
                loading={loading}
                title={messages['change_password_title']}
                size="small"
                handleClose={() => closeModal()}
            >
                <ModalBody>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            if (newPassword !== confirmPassword) {
                                setValidPassword(messages['change_password_passwords_must_match']);
                                return
                            }
                            let checkPassword = passwordValidation(newPassword);
                            if (checkPassword) {
                                dispatch(changePasswordRequest({
                                    oldPassword,
                                    newPassword,
                                    accessToken: localStorage.getItem("AccessToken")
                                }))
                                //lauch

                            } else {
                                NotificationManager.error(
                                    messages['error_password'],
                                    messages['change_password_title'],
                                    3000
                                );
                            }
                        }}
                    >
                        <div className="change-password-container">
                            <div style={{ marginTop: 5 }}>
                                <Input
                                    type="password"
                                    label={messages['change_password_old_password']}
                                    placeholder={messages['change_password_old_password']}
                                    value={oldPassword}
                                    onChange={(value) => {
                                        setValidPassword("")
                                        setOldPassword(value);
                                    }}
                                    requiredMessage={messages['required_field']}
                                    required
                                />
                            </div>
                            <div style={{ marginTop: 5 }}>
                                <Input
                                    type="password"
                                    label={messages['change_password_new_password']}
                                    placeholder={messages['change_password_new_password']}
                                    value={newPassword}
                                    onChange={(value) => {
                                        setValidPassword("");
                                        setNewPassword(value);
                                    }}
                                    requiredMessage={messages['required_field']}
                                    required
                                    maxLength={20}
                                    minLength={6}
                                    minLengthMessage={`${messages['pmusers_min_chars_password']} 6`}
                                    maxLengthMessage={`${messages['pmusers_max_chars_password']} 20`}
                                />
                            </div>
                            <div style={{ marginTop: 5 }}>
                                <Input
                                    type="password"
                                    label={messages['change_password_repeat_new_password']}
                                    placeholder={messages['change_password_repeat_new_password']}
                                    value={confirmPassword}
                                    onChange={(value) => {
                                        setValidPassword("");
                                        setConfirmPassword(value)
                                    }}
                                    requiredMessage={messages['required_field']}
                                    required
                                    maxLength={20}
                                    minLength={6}
                                    minLengthMessage={`${messages['pmusers_min_chars_password']} 6`}
                                    maxLengthMessage={`${messages['pmusers_max_chars_password']} 20`}
                                />
                            </div>

                            {
                                validPassword &&
                                <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }}>{validPassword}</p>
                            }

                        </div>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <div className="change-password-footer">
                        <Button
                            className="btn-cancel"
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal();
                            }}
                        >
                            {messages['common_cancel']}
                        </Button>
                        <Button
                            className="btn-dark-blue"
                            onClick={(e) => {
                                e.preventDefault();
                                formRef.current.submit()
                            }}
                        >
                            {messages['account_change_label']}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
            {logoutPromptOpenModal && <LogoutPrompt closeModal={closeModal} />}
        </>
    )
}
export default ChangePassword;